module.exports = __webpack_public_path__ + "img/name.c8a86428.png";